import {createReducer} from '@reduxjs/toolkit';

import {setDataFromHostStore} from '../../actions';
import {getQuote} from '../quoteItems/quoteItems';

import {QuoteInfoType} from './quoteInfoType';

export const initialState: QuoteInfoType = {
    id: '',
    shareId: null,
    specialOffer: '',
    specialOffers: null,
};

/**
 * Get cart quote info
 *
 * @param {QuoteInfoType} state - Current state
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {QuoteInfoType} Cart quote data
 */
export const quoteInfo = createReducer<QuoteInfoType>(initialState, builder =>
    builder
        .addCase(setDataFromHostStore, (state, action) => action.payload?.quoteInfo || state)
        .addCase(getQuote.fulfilled, (_, action) => {
            const {cartKey: shareId, id, specialOffer, specialOffers} = action.payload?.data;
            return {
                id,
                shareId,
                specialOffer,
                specialOffers,
            };
        }),
);
